"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[513,5909],{

/***/ 513:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _services_Log__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(27429);
/* harmony import */ var _helpers_handleTildedField__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(20363);
/* harmony import */ var _helpers_addParamsToUrl__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(54552);
/* harmony import */ var _hooks_DmpAnalytics_pushDMPAnalyticsEvent__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(15909);
/* eslint-disable react/jsx-one-expression-per-line */ 








var Carousel = next_dynamic__WEBPACK_IMPORTED_MODULE_2___default()(__webpack_require__.e(/* import() */ 4970).then(__webpack_require__.bind(__webpack_require__, 44970)), {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(44970)
            ];
        }
    }
});
var ProductTile = next_dynamic__WEBPACK_IMPORTED_MODULE_2___default()(Promise.all(/* import() */[__webpack_require__.e(3996), __webpack_require__.e(7202)]).then(__webpack_require__.bind(__webpack_require__, 27202)), {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(27202)
            ];
        }
    }
});
var Text = next_dynamic__WEBPACK_IMPORTED_MODULE_2___default()(__webpack_require__.e(/* import() */ 5468).then(__webpack_require__.bind(__webpack_require__, 45468)), {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(45468)
            ];
        }
    }
});
var listrakImageStyleMap = {
    mobile: {
        minWidth: "144px",
        minHeight: "144px"
    },
    desktop: {
        minWidth: "264px",
        minHeight: "264px"
    }
};
var dedupSkus = function(arr) {
    var seen = new Set();
    return arr.filter(function(item) {
        if (seen.has(item.sku)) return false;
        seen.add(item.sku);
        return true;
    });
};
var ListrackRecommendationUi = function(param) {
    var isMobile = param.isMobile, block = param.block, isFreeRugDoorstepShippingOn = param.isFreeRugDoorstepShippingOn, addToCartFunction = param.addToCartFunction;
    /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Carousel, {
        className: "overflow-hidden",
        carrouselHeader: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Text, {
            textId: "text-body-xl-bold px-2",
            children: block.carrouselHeader
        }),
        isMobile: isMobile,
        children: dedupSkus(block.products).map(function(product, listrakRecommendationIndex) {
            var ref, ref1;
            /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                style: listrakImageStyleMap[isMobile ? "mobile" : "desktop"],
                className: "mx-2 relative",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ProductTile, {
                    addToCartFunction: addToCartFunction,
                    onImpressionEvent: function() {
                        var ref, ref1, ref2, ref3;
                        (0,_hooks_DmpAnalytics_pushDMPAnalyticsEvent__WEBPACK_IMPORTED_MODULE_5__.sendDMPAnalyticsEvent)({
                            eventType: "recommendation-impression",
                            items: [
                                {
                                    salePrice: (ref = product.variants) === null || ref === void 0 ? void 0 : (ref1 = ref[0]) === null || ref1 === void 0 ? void 0 : ref1.sale_price,
                                    price: (ref2 = product.variants) === null || ref2 === void 0 ? void 0 : (ref3 = ref2[0]) === null || ref3 === void 0 ? void 0 : ref3.price,
                                    sku: product.sku,
                                    quantity: 1
                                }
                            ],
                            context: [
                                {
                                    key: "mechandiseBlockId",
                                    value: {
                                        stringValue: block.mechandiseBlockId,
                                        numberValue: 0,
                                        booleanValue: false
                                    }
                                },
                                {
                                    key: "mechandiseBlockName",
                                    value: {
                                        stringValue: block.name,
                                        numberValue: 0,
                                        booleanValue: false
                                    }
                                },
                                {
                                    key: "RecommendationIndex",
                                    value: {
                                        stringValue: String(listrakRecommendationIndex),
                                        numberValue: listrakRecommendationIndex,
                                        booleanValue: false
                                    }
                                }
                            ]
                        });
                    },
                    product: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, product), {
                        colorChips: undefined,
                        readyToShip: false,
                        brand: "",
                        custom_url: {
                            url: (0,_helpers_addParamsToUrl__WEBPACK_IMPORTED_MODULE_4__/* .addParamsToUrl */ .S)(product.custom_url.url, {
                                listrakMechandiseBlockId: block.mechandiseBlockId,
                                listrakRecommendationIndex: String(listrakRecommendationIndex),
                                listrakRecommendationBlockName: block.name,
                                sku: (ref = product.variants) === null || ref === void 0 ? void 0 : (ref1 = ref[0]) === null || ref1 === void 0 ? void 0 : ref1.sku
                            })
                        },
                        FreeShipping: product.FreeShipping || isFreeRugDoorstepShippingOn && product.hasDoorstepEligibleRug,
                        is_free_shipping_eligible: isFreeRugDoorstepShippingOn && !product.hasDoorstepEligibleRug && product.allVariantsAreDSElligibleRugs
                    }),
                    lazyLoad: true,
                    changeImageOnHover: true,
                    capSize: true
                })
            }, "".concat(block.mechandiseBlockId, "-").concat(product.sku));
        })
    });
};
var ListrakRecommendation = function(param) {
    var isMobile = param.isMobile, block = param.block, index = param.index, isFreeRugDoorstepShippingOn = param.isFreeRugDoorstepShippingOn, addToCartFunction = param.addToCartFunction;
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        (0,_services_Log__WEBPACK_IMPORTED_MODULE_3__/* .debug */ .fF)("Listrak recommendation view_item", {
            block: block
        });
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            ecommerce: null
        }) // Clear the previous ecommerce object.
        ;
        window.dataLayer.push({
            // event: 'view_recommendation_list',
            event: "view_item_list",
            ecommerce: {
                recommendation: {
                    item_list_name: block.name,
                    item_list_id: block.mechandiseBlockId,
                    rank: String(index),
                    items: block.products.map(function(product) {
                        return {
                            item_id: product.sku,
                            item_name: (0,_helpers_handleTildedField__WEBPACK_IMPORTED_MODULE_8__/* .handleTildedField */ .G)(product.name)
                        };
                    })
                }
            }
        });
    }, [
        block,
        index
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ListrackRecommendationUi, {
        addToCartFunction: addToCartFunction,
        isFreeRugDoorstepShippingOn: isFreeRugDoorstepShippingOn,
        isMobile: isMobile,
        block: block
    });
};
/* harmony default export */ __webpack_exports__["default"] = (ListrakRecommendation);


/***/ }),

/***/ 54552:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "S": function() { return /* binding */ addParamsToUrl; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(828);
/* harmony import */ var _services_Configuration__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(16977);
/* harmony import */ var _services_Configuration__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_services_Configuration__WEBPACK_IMPORTED_MODULE_0__);


var getUrlFromMaybUrlMaybePath = function(maybeUrlMaybePath) {
    return maybeUrlMaybePath.startsWith("http") ? maybeUrlMaybePath : "".concat(_services_Configuration__WEBPACK_IMPORTED_MODULE_0__.SHOP_ORIGIN).concat(maybeUrlMaybePath);
};
var addParamsToUrl = function(maybeUrlMaybePath, params) {
    var urlStr = getUrlFromMaybUrlMaybePath(maybeUrlMaybePath);
    var urlObj = new URL(urlStr);
    Object.entries(params).forEach(function(param) {
        var _param = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(param, 2), key = _param[0], value = _param[1];
        urlObj.searchParams.set(key, value);
    });
    return urlObj.toString();
};


/***/ }),

/***/ 20363:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "G": function() { return /* binding */ handleTildedField; }
/* harmony export */ });
var handleTildedField = function(value) {
    return "".concat(value).split("~")[0];
};
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ((/* unused pure expression or super */ null && (handleTildedField)));


/***/ }),

/***/ 15909:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "sendDMPAnalyticsEvent": function() { return /* binding */ sendDMPAnalyticsEvent; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(828);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(29815);
/* harmony import */ var _codebuild_output_src2623904418_src_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _codebuild_output_src2623904418_src_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_codebuild_output_src2623904418_src_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _services_Log__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(27429);
/* harmony import */ var _recoiljs_refine__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(30901);
/* harmony import */ var _services_Configuration__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(16977);
/* harmony import */ var _services_Configuration__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_services_Configuration__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _helpers_allPromisesWithRetries__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(48080);
/* harmony import */ var _helpers_FP__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(13174);
/* provided dependency */ var Buffer = __webpack_require__(48764)["Buffer"];











var Event = (0,_recoiljs_refine__WEBPACK_IMPORTED_MODULE_2__/* .object */ .Ry)({
    uuid: (0,_recoiljs_refine__WEBPACK_IMPORTED_MODULE_2__/* .string */ .Z_)(),
    userUUID: (0,_recoiljs_refine__WEBPACK_IMPORTED_MODULE_2__/* .string */ .Z_)(),
    date: (0,_recoiljs_refine__WEBPACK_IMPORTED_MODULE_2__/* .string */ .Z_)(),
    eventType: (0,_recoiljs_refine__WEBPACK_IMPORTED_MODULE_2__/* .string */ .Z_)(),
    url: (0,_recoiljs_refine__WEBPACK_IMPORTED_MODULE_2__/* .string */ .Z_)(),
    items: (0,_recoiljs_refine__WEBPACK_IMPORTED_MODULE_2__/* .array */ .IX)((0,_recoiljs_refine__WEBPACK_IMPORTED_MODULE_2__/* .object */ .Ry)({
        sku: (0,_recoiljs_refine__WEBPACK_IMPORTED_MODULE_2__/* .string */ .Z_)(),
        salePrice: (0,_recoiljs_refine__WEBPACK_IMPORTED_MODULE_2__/* .number */ .Rx)(),
        price: (0,_recoiljs_refine__WEBPACK_IMPORTED_MODULE_2__/* .number */ .Rx)(),
        quantity: (0,_recoiljs_refine__WEBPACK_IMPORTED_MODULE_2__/* .number */ .Rx)()
    })),
    context: (0,_recoiljs_refine__WEBPACK_IMPORTED_MODULE_2__/* .array */ .IX)((0,_recoiljs_refine__WEBPACK_IMPORTED_MODULE_2__/* .object */ .Ry)({
        key: (0,_recoiljs_refine__WEBPACK_IMPORTED_MODULE_2__/* .string */ .Z_)(),
        value: (0,_recoiljs_refine__WEBPACK_IMPORTED_MODULE_2__/* .object */ .Ry)({
            stringValue: (0,_recoiljs_refine__WEBPACK_IMPORTED_MODULE_2__/* .nullable */ .AG)((0,_recoiljs_refine__WEBPACK_IMPORTED_MODULE_2__/* .string */ .Z_)()),
            numberValue: (0,_recoiljs_refine__WEBPACK_IMPORTED_MODULE_2__/* .nullable */ .AG)((0,_recoiljs_refine__WEBPACK_IMPORTED_MODULE_2__/* .number */ .Rx)()),
            booleanValue: (0,_recoiljs_refine__WEBPACK_IMPORTED_MODULE_2__/* .nullable */ .AG)((0,_recoiljs_refine__WEBPACK_IMPORTED_MODULE_2__/* .bool */ .Xg)())
        })
    }))
});
var assertEvent = (0,_recoiljs_refine__WEBPACK_IMPORTED_MODULE_2__/* .assertion */ .P5)(Event, "Invalid DMP Analytics Event");
var client = null;
var uuidRegex = /[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}/;
var localStorageDMPUserUUIDKey = "dmpUserUUID";
var getLocalStorageUserUUID = function() {
    try {
        var value = localStorage.getItem(localStorageDMPUserUUIDKey);
        if (value && uuidRegex.test(value)) {
            return value;
        }
    } catch (e) {
        return null;
    }
    return null;
};
var loadUserUUID = function(uuidGenerator) {
    var fromLocalStorage = getLocalStorageUserUUID();
    if (fromLocalStorage) {
        return fromLocalStorage;
    }
    var generated = uuidGenerator();
    localStorage.setItem(localStorageDMPUserUUIDKey, generated);
    return generated;
};
var sendEventHappyPath = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_codebuild_output_src2623904418_src_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(event) {
        var ref, ref1, FirehoseClient, PutRecordBatchCommand, fromCognitoIdentityPool, ref2, uuidv4, getComposeAssignmentMap, trackAmplitudeFromDMPEvent, eventData, sendFirehosePromise, amplitudePromise, results;
        return _codebuild_output_src2623904418_src_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.t0 = _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z;
                    _ctx.next = 3;
                    return (0,_helpers_allPromisesWithRetries__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(function() {
                        return [
                            Promise.all(/* import() */[__webpack_require__.e(4354), __webpack_require__.e(5330)]).then(__webpack_require__.bind(__webpack_require__, 65330)),
                            Promise.all(/* import() */[__webpack_require__.e(3601), __webpack_require__.e(3424)]).then(__webpack_require__.bind(__webpack_require__, 83601)),
                            __webpack_require__.e(/* import() */ 6578).then(__webpack_require__.bind(__webpack_require__, 46578)),
                            __webpack_require__.e(/* import() */ 5434).then(__webpack_require__.bind(__webpack_require__, 85434)),
                            __webpack_require__.e(/* import() */ 9378).then(__webpack_require__.bind(__webpack_require__, 29378)), 
                        ];
                    });
                case 3:
                    _ctx.t1 = _ctx.sent;
                    ref = (0, _ctx.t0)(_ctx.t1, 5);
                    ref1 = ref[0];
                    FirehoseClient = ref1.FirehoseClient;
                    PutRecordBatchCommand = ref1.PutRecordBatchCommand;
                    fromCognitoIdentityPool = ref[1].fromCognitoIdentityPool;
                    ref2 = ref[2];
                    uuidv4 = ref2.v4;
                    getComposeAssignmentMap = ref[3].getComposeAssignmentMap;
                    trackAmplitudeFromDMPEvent = ref[4].trackAmplitudeFromDMPEvent;
                    eventData = assertEvent((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({
                        url: window.location.href,
                        uuid: String(event.uuid || (uuidv4 === null || uuidv4 === void 0 ? void 0 : uuidv4())),
                        userUUID: loadUserUUID(uuidv4),
                        date: new Date().toISOString()
                    }, event), {
                        context: (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(event.context).concat([
                            {
                                key: "A/B tests",
                                value: {
                                    stringValue: JSON.stringify(getComposeAssignmentMap())
                                }
                            }, 
                        ])
                    }));
                    trackAmplitudeFromDMPEvent(eventData);
                    client = client || new FirehoseClient({
                        region: _services_Configuration__WEBPACK_IMPORTED_MODULE_3__.FIREHOSE_REGION,
                        credentials: fromCognitoIdentityPool({
                            clientConfig: {
                                region: _services_Configuration__WEBPACK_IMPORTED_MODULE_3__.COGNITO_REGION
                            },
                            identityPoolId: _services_Configuration__WEBPACK_IMPORTED_MODULE_3__.COGNITO_IDENTITY_POOL_ID
                        })
                    });
                    (0,_services_Log__WEBPACK_IMPORTED_MODULE_1__/* .log */ .cM)("sendDMPAnalyticsEvent: Firehose client created");
                    if (!client) {
                        _ctx.next = 26;
                        break;
                    }
                    (0,_services_Log__WEBPACK_IMPORTED_MODULE_1__/* .log */ .cM)("Sending page view");
                    sendFirehosePromise = client.send(new PutRecordBatchCommand({
                        DeliveryStreamName: _services_Configuration__WEBPACK_IMPORTED_MODULE_3__.FIREHOSE_DELIVERY_STREAM_NAME,
                        Records: [
                            {
                                Data: Buffer.from(JSON.stringify(eventData))
                            }, 
                        ]
                    }));
                    amplitudePromise = trackAmplitudeFromDMPEvent(eventData);
                    _ctx.next = 23;
                    return Promise.allSettled([
                        sendFirehosePromise,
                        amplitudePromise, 
                    ]);
                case 23:
                    results = _ctx.sent;
                    results.forEach(function(result) {
                        if (result.status === "rejected") {
                            (0,_services_Log__WEBPACK_IMPORTED_MODULE_1__/* .error */ .vU)("result", result);
                        }
                    });
                    (0,_services_Log__WEBPACK_IMPORTED_MODULE_1__/* .log */ .cM)("sendDMPAnalyticsEvent: Page view sent");
                case 26:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function sendEventHappyPath(event) {
        return _ref.apply(this, arguments);
    };
}();
var sendEventSadPath = function(err) {
    (0,_services_Log__WEBPACK_IMPORTED_MODULE_1__/* .error */ .vU)("sendDMPAnalyticsEvent: Error sending event: ".concat(String(err)));
};
var sendDMPAnalyticsEvent = (0,_helpers_FP__WEBPACK_IMPORTED_MODULE_5__/* .thenCaught */ .HA)(sendEventHappyPath)(sendEventSadPath);


/***/ })

}]);